import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentMasteryTestRepeatRateGauge from './ContentMasteryTestRepeatRateGauge';
import { ContentMasteryRepeatRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentMasteryTestRepeatRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentMasteryRepeatRateListService.load();
  }
  render() {
    const data = ContentMasteryRepeatRateListService.getChart();
    return (
      <ContentMasteryTestRepeatRateGauge
        loading={
          ContentMasteryRepeatRateListService.fetchCurrent.fetching ||
          ContentMasteryRepeatRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentMasteryRepeatRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('MASTERY_TEST_ITEM_EXECUTION_REPEAT_RATE')}
      />
    );
  }
}

export default observer(ContentMasteryTestRepeatRateGaugeContainer);
